import { useState } from "react";
import ServerTable from "../../../components/atoms/tables/serverTable";
import { useLocation, useNavigate } from "react-router-dom";
const HistoryLeaveSettings = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const uid = location.pathname.split("/").pop();
    const [filters, setFilters] = useState({
        employee: uid
    });
    const columns = [
        {
            name: "Change",
            selector: "differenceInLeaves",
        },
        {
            name: "Number of Leaves",
            // selector: "newLeaves",
            cell: (row) => {
                return <>
                New: {' '}{row.newLeaves} <br/> <br/> Old: {' '}{row.oldLeaves}
                </>
            }
        },
        // {
        //     name: "Old Total",
        //     selector: "oldLeaves",
        // },
        {
            name: "Leave Balance",
            // selector: "newLeaveBalance",
            cell: (row) => {
                return <>
                New: {' '}{row.newLeaveBalance} <br/> <br/> Old: {' '}{row.oldLeaveBalance}
                </>
            }
        },
        // {
        //     name: "Old Balance",
        //     selector: "oldLeaveBalance",
        // },
        {
            name: "Working Days",
            cell: (row) => {
                return <>
                New:  <br/> {' '}{(row.newWorkingDays).join(", ")} <br/>  <br/>  Old:  <br/> {' '}{(row.oldWorkingDays).join(", ")}
                </>
            }
        },
        {
            name: "Time Period",
            cell: (row) => {
                return <>
                New: {' '}{row.newTimePeriod} <br/> <br/> Old: {' '}{row.oldTimePeriod}
                </>
            }
        },
        {
            name: "Start Month",
            cell: (row) => {
                return <>
                New: {' '}{row.newStartMonth} <br/> <br/> Old: {' '}{row.oldStartMonth}
                </>
            }
        },
        {
            name: "Updated At",
            selector: "updated_at",
            sortable: true,
            cell: (row) => {
                return <>
                    {new Date(row.updated_at).toLocaleDateString()}
                </>
            }
        }
    ];
    return (
        <div>
            <div >
                <button
                    onClick={() => {
                        navigate(`/employees/${uid}`);
                    }}
                    type="button" className="inline-flex items-center rounded border border-gray-300 bg-white ml-2 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                    Back To Employee
                </button>

            </div>
            <div className='mt-4'>
                <ServerTable
                    key={JSON.stringify(filters)}
                    apiURL={'/employee/history/get-leave-settings'}
                    columns={columns}
                    filters={filters}
                />
            </div>
        </div>
    )
}
export default HistoryLeaveSettings;